import { render, staticRenderFns } from "./m-addAnswer.vue?vue&type=template&id=1b88a378&"
import script from "./m-addAnswer.vue?vue&type=script&lang=js&"
export * from "./m-addAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports